import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'maskString',
})
export class MaskStringPipe implements PipeTransform {
    public transform(value: string): string {
        return '••••  ••••  ••••  ' + value.slice(-4);
    }
}
